// extracted by mini-css-extract-plugin
export var staffMember = "StaffMembers-module--staffMember--6926e";
export var staffMembers = "StaffMembers-module--staffMembers--70f87";